import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { SocialLoginType } from '../types';

export const useLogClickSocialAccount = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (type: SocialLoginType) => {
      logAnalyticsEvent({
        name: 'CLICK_SOCIAL_ACCOUNT',
        analytics: {
          SCREEN: 'INTRO_SIGN_UP',
          ACCOUNT_TYPE: type.toUpperCase(),
        },
      });
    },
    [logAnalyticsEvent],
  );
};
